import React, { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import ReturnToLocationModal from "./ReturnToLocationModal";

export default function ReturnToLocationButton({ item, asset }) {
  const [open, setOpen] = useState(false);
  const isCompleted = item.completedStatus;

  const handleClick = () => setOpen(true);

  if (isCompleted) {
    return (
      <Box
        display="inline-block"
        bgcolor="#D5F5D5"
        px={1}
        py={0.5}
        borderRadius={1}
        textAlign="center"
      >
        <Typography fontWeight="500">Returned to Storage</Typography>
      </Box>
    );
  }

  return (
    <>
      <Button
        variant="outlined"
        color="primary"
        size="small"
        onClick={handleClick}
        sx={{ whiteSpace: "nowrap" }}
      >
        Return to Storage
      </Button>
      {open && (
        <ReturnToLocationModal
          item={item}
          asset={asset}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
}
